module.exports = __webpack_public_path__ + "static/media/hold-phone-mid.ed353de7.png";